import { GIFT, redeemGiftColumns } from './constants';
import TableHeader from './TableHeader';
import * as styles from './redemptionTable.module.scss';

type Column = {
  redemptionCode: string;
};

type TableProps = {
  selected: string;
  list: Column[];
};

type RenderRowsProps = {
  selected: string;
  list: Column[];
  currentColumns: { id: string }[];
};

const RenderRows = ({ selected, list, currentColumns }: RenderRowsProps) => {
  if (list.length <= 0) {
    return (
      <tr className="odd">
        <td valign="top" colSpan={selected === GIFT ? 3 : 4} className={styles.datatablesEmpty}>
          No items found
        </td>
      </tr>
    );
  }

  return list.map((element) => (
    <tr key={element.redemptionCode} className="odd">
      {currentColumns.map(({ id }) => (
        <td key={`${element.redemptionCode}-${id}`} valign="top" colSpan={1}>
          {element[id as keyof Column]}
        </td>
      ))}
    </tr>
  ));
};

const Table = ({ selected = GIFT, list = [] }: TableProps) => {
  return (
    <div className={styles.fffTabContent}>
      <div className={styles.tableResponsive}>
        <div className={styles.datatablesWrapper}>
          <table className={styles.datatable} role="grid">
            <TableHeader columns={redeemGiftColumns} />
            <tbody>
              <RenderRows selected={selected} list={list} currentColumns={redeemGiftColumns} />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
